export default __webpack_public_path__ + "images/xdai_94218f.svg";